module.exports = __webpack_public_path__ + "group.53f4cb982ebaae8ff1fc1bfa6fb5c5f0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/selected/group.svg
// module id = 322
// module chunks = 0